var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoodfitBadgeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14881_28186)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.2122 25.2876H12.1583V15.448L17.3506 8.0601C17.6398 7.64918 18.0589 7.34745 18.5403 7.20339C19.0217 7.05934 19.5376 7.08134 20.005 7.26585C20.4725 7.45035 20.8643 7.78666 21.1175 8.22071C21.3707 8.65477 21.4707 9.16135 21.4013 9.65906L21.0127 12.4581H24.4341C25.9299 12.4581 28.9232 13.9539 28.9232 16.9455C28.9232 19.9371 25.9145 26.7834 22.732 26.7834C18.5421 26.7834 14.9573 25.7862 13.2122 25.2876ZM7.43018 15.0611C7.43018 13.7545 8.48927 12.6971 9.79422 12.6971C11.1009 12.6971 12.1583 13.7562 12.1583 15.0611V24.9471C12.1583 26.2538 11.0992 27.3112 9.79422 27.3112C8.48755 27.3112 7.43018 26.2521 7.43018 24.9471V15.0611Z",
    stroke: "#226BCC",
    strokeWidth: 1.71931,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14881_28186"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.0703,
    height: 24.0703,
    fill: "white",
    transform: "translate(6.14062 5.82031)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoodfitBadgeIcon);
export default __webpack_public_path__ + "static/media/Goodfit-badge-icon.bf0823409ca25fcee336ab10948fae00.svg";
export { ForwardRef as ReactComponent };